// This is a knockout implementation of the old 'expandable' class from tkzero.
module.exports = {
  init: function(element, valueAccessor, allBindingsAccessor, viewModel) {
    var $element = $(element);
    if (valueAccessor()) {
      $element.toggleClass('opened');
    }

    $element.find('.switch').click(function() {
      $element.toggleClass('opened');
      valueAccessor(true);
    });
  }
};
